import { Component, Output, EventEmitter, Input, OnChanges, OnInit } from '@angular/core';
import { SystemService } from '../../services/system.service';
/**
 * Created On : 13th Feb 2018
 * Usage : Displays timeline buttons and emit selected time 
 * Coprights : Johnson Controls India Pvt Ltd.
 **/
@Component({
  selector: 'timeline',
  templateUrl: 'timeline.html'
})
export class TimelineComponent {

  public selectedDuration: number;
  public showModal: boolean;

  @Input() tab: string;
  @Output() selectTimeDuration = new EventEmitter();

  constructor(
    private systemService: SystemService
  ) {
    this.showModal = this.systemService.get();
    this.systemService.showModalEventEmitter.subscribe((value) => this.showModal = value);
  }

  ngOnInit(){
    this.tab == 'alerts' ? this.selectedDuration = 4 : this.selectedDuration = Number(sessionStorage.getItem('trendsTimeDuration'));
  }

  ngOnChanges(){
    this.tab == 'alerts' ? this.selectedDuration = 4 : this.selectedDuration = Number(sessionStorage.getItem('trendsTimeDuration'));
  }

  selectDuration(duration){
    this.selectedDuration = duration;
    if(this.tab == 'trends'){
      sessionStorage.setItem('trendsTimeDuration', String(duration));
    }
    this.selectTimeDuration.emit(duration);
  }

  selectSystem(){
    this.showModal = !this.showModal;
    this.systemService.set(this.showModal);
  }


}



// WEBPACK FOOTER //
// ./src/components/timeline/timeline.ts